import { Link } from "react-router";
import { Backdrop } from "@/components/ui/backdrop";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="app cs-checker relative isolate items-center justify-center overflow-hidden p-6">
      <Backdrop art="not-found" className="page-art" />
      <div className="flex max-w-[420px] flex-col items-center gap-4 text-center">
        <span className="num-xl muted">404</span>
        <h1 className="display-lg">页面不存在</h1>
        <p className="page-sub">链接可能已失效，或者你没有访问权限。</p>
        <Button asChild variant="default">
          <Link to="/demos">返回 Demo 库</Link>
        </Button>
      </div>
    </div>
  );
}
